import { createConfig, createFlowContext } from '@betterment/shared-components';
import { Outlet } from 'react-router-dom';
import * as Yup from 'yup';

export const ADHOC_DOCUMENT_VERIFICATION_FLOW_CONFIG = createConfig({
  instructions: {
    schema: Yup.object({}),
    dependencies: Yup.object({}),
  },
  upload: {
    schema: Yup.object({}),
    dependencies: Yup.object({}),
  },
  success: {
    schema: Yup.object({}),
    dependencies: Yup.object({}),
  },
});

export const { FlowProvider, useStep: useAdhocDocumentVerificationStep } = createFlowContext(
  ADHOC_DOCUMENT_VERIFICATION_FLOW_CONFIG
);

export const AdhocDocumentVerificationFlow = () => (
  <FlowProvider>
    <Outlet />
  </FlowProvider>
);
